import Auth from '@Services/Auth';
import UserDatabases from '@Services/UserDatabases';
import { RxSocketUrls } from '@Constants/CommonConstants';
import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';
import SocketBroker from '@Services/SocketBroker';

function _getMolByHttp(params) {
  Logger.info('Insert structure from name - HTTP send', params);
  return MessageBroker.send(RequestUrls.structureFromName, params)
    .then((response) => {
      Logger.info('Insert structure from name - HTTP response', response);
      return response;
    })
    .catch(Logger.reject);
}

function _getMolByWS(payload) {
  const channels = {
    send: RxSocketUrls.ChannelsUrls.gsfn.create,
    message: RxSocketUrls.ChannelsUrls.gsfn.result,
  };

  let socketSubject;
  let unregisterErrors = SocketBroker.observe(RxSocketUrls.ChannelsUrls.QueueErrors, (error) => {
    // eslint-disable-next-line no-unused-expressions
    unregisterErrors && unregisterErrors();
    unregisterErrors = null;
    // eslint-disable-next-line no-unused-expressions
    socketSubject && socketSubject.cancel(error);
  });

  Logger.info('Insert structure from name - WS send', payload);

  socketSubject = SocketBroker.send(channels, { params: payload, oneTime: true });

  // socketSubject.subscribe(
  //   ({ data }) => {
  //     // eslint-disable-next-line no-shadow
  //     const { info, payload } = data;
  //     // eslint-disable-next-line no-unused-expressions
  //     unregisterErrors && unregisterErrors();
  //     unregisterErrors = null;
  //     Logger.info('Insert structure from name - WS response', { info, payload });
  //     return payload;
  //   },
  //   (error) => {
  //     Logger.reject(error);
  //   }
  // );

  return new Promise((resolve) => {
    socketSubject.subscribe(
      ({ data }) => {
        // eslint-disable-next-line no-shadow
        const { info, payload } = data;
        // eslint-disable-next-line no-unused-expressions
        unregisterErrors && unregisterErrors();
        unregisterErrors = null;
        Logger.info('Insert structure from name - WS response', { info, payload });
        resolve(payload);
      },
      (error) => {
        Logger.reject(error);
      }
    );
  });
}

// eslint-disable-next-line import/prefer-default-export
export function getMolForStructure(textValue, option, useHttp = false) {
  const user = Auth.getUser();
  const userDbs = user && user.details ? Object.keys(user.details.databases) : null;
  const params = {
    textValue,
    option,
    databases: userDbs || [UserDatabases.getDefaultDatabase().id],
  };

  return useHttp ? _getMolByHttp(params) : _getMolByWS(params);
}
